.<template>
  <div class="">
    <div class="col">
      <div v-if="lsWeekDays && lsWeekDays.length" class="d-flex">
        <div
          class="checkbox d-flex align-item-center mr-15px"
          v-for="(day, index) in lsWeekDays"
          :key="index"
        >
          <input
            type="checkbox"
            class="m-auto mr-10px ml-0px c-pointer"
            :id="day.name"
            v-on:input="onDaysSelection(day)"
            :checked="lsSelectedDays.includes(day.code)"
          />

          <label :for="day.name" :class="'mb-0 c-pointer'">{{
            day.name
          }}</label>
        </div>
      </div>
      <ValidationProvider v-if="!allowEmpty" :rules="'required'" v-slot="{ errors }">
        <CRow v-model="lsSelectedDays"></CRow>
        <div v-if="errors && errors[0]" class="invalid-feedback icon">
          <span>{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import { ToggleButton } from "vue-js-toggle-button";
import { mapGetters, mapActions } from "vuex";
import {
  PATHNAME,
  COMPONENT_NAME,
  DEFAULT_DROPDOWN_STATUS,
  PAX_TITLE,
} from "../../util/constants.js";
import BaseConfiguration from "../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../util/apiValidate.js";
import { handleJWT, getErrorAlertValue, cloneData, cloneDeep } from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
import Logger from "../../services/logger";
import router, { navigate, goBack } from "../../router/index";

import cAlertModal from "./cAlertModal";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../config/API_DATA";
export default {
  name: COMPONENT_NAME.C_WEEK_DAYS,

  components:{
    ValidationProvider
  },


  props:{
    allowEmpty:{
      type:Boolean,
      default:false
    },

   selDays:{
     type:Array,
     default:null
   }


  },

  data: () => {
    return {
      lsWeekDays: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      lsSelectedDays: [],
    };
  },

  methods: {
    sortWeekDays(lsSelectedDays) {
      let retValue=[]
      try {
        if (BaseConfiguration.isDebug) console.log("sortWeekDays");

        if (lsSelectedDays &&lsSelectedDays.length) {
          let indexArr = [];
          let allDays =cloneDeep(this.lsWeekDays)
          allDays=  allDays.map(day=>day.code)

         lsSelectedDays.forEach((v) => {
            indexArr.push(allDays.indexOf(v));
          });
          indexArr = indexArr.sort();

        lsSelectedDays = [];
          for (let index = 0; index < indexArr.length; index++) {
            if (allDays[index] != null) {
            lsSelectedDays.push(allDays[indexArr[index]]);
            }
          }
        }
        else{
      lsSelectedDays=[]
        }

        retValue =cloneDeep(lsSelectedDays)
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_WEEK_DAYS,
          "error in sortWeekDays",
          err.toString(),
          "sortWeekDays",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue
    },

    onDaysSelection(pWeekDay) {
      try {
        if (BaseConfiguration.isDebug) console.log("onDaysSelection");

        if (pWeekDay && !this.lsSelectedDays.includes(pWeekDay.code)) {
          this.lsSelectedDays.push(pWeekDay.code);
        } else {
          this.lsSelectedDays = this.lsSelectedDays.filter(
            (day) => day != pWeekDay.code
          );
        }

        this.lsSelectedDays=   this.sortWeekDays(this.lsSelectedDays)
        this.$emit('onDaysSelection',this.lsSelectedDays)

      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_WEEK_DAYS,
          "error in onDaysSelection",
          err.toString(),
          "onDaysSelection",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getWeekDays() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getWeekDays");
        retValue = [
          {
            name: this.$t("cWeekDays.SUN"),
            code: "SUN",
          },
          {
            name: this.$t("cWeekDays.MON"),
            code: "MON",
          },
          {
            name: this.$t("cWeekDays.TUE"),
            code: "TUE",
          },
          {
            name: this.$t("cWeekDays.WED"),
            code: "WED",
          },
          {
            name: this.$t("cWeekDays.THU"),
            code: "THU",
          },
          {
            name: this.$t("cWeekDays.FRI"),
            code: "FRI",
          },
          {
            name: this.$t("cWeekDays.SAT"),
            code: "SAT",
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_WEEK_DAYS,
          "error in getWeekDays",
          err.toString(),
          "getWeekDays",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
  },

  created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      this.lsWeekDays = this.getWeekDays();

          if(this.selDays && this.selDays.length)
          {
            this.lsSelectedDays = cloneDeep(this.selDays)
          }
          else{
            this.lsSelectedDays=[];
          }

    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_WEEK_DAYS,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};
</script>

<style></style>
